// extracted by mini-css-extract-plugin
var _1 = "InhabitantFormFields-moduleactions__yN0Bx FormActions-moduleFormActions__WNNEs";
var _2 = "InhabitantFormFields-modulefieldWrapper__RRsSI";
var _3 = "InhabitantFormFields-moduleformFields__qZJNa FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "actions", _2 as "fieldWrapper", _3 as "formFields" }
